import StatusChip from "@entrilia/shared/components/StatusChip";
import type { AssistantRunStatus } from "../../../api/types/assistantTypes";

interface Props {
  status: AssistantRunStatus;
  height?: "smaller";
}

const RunStatusChip = ({ status, height }: Props) => {
  switch (status) {
    case "Completed":
      return <StatusChip label="Done" color={(t) => t.palette.success.main} height={height} />;
    case "Failed":
      return <StatusChip label="Failed" color={(t) => t.palette.error.main} height={height} />;
    case "Stopped":
      return <StatusChip label="Stopped" color={(t) => t.palette.text.secondary} neutral height={height} />;
    case "WaitingForApproval":
      return <StatusChip label="Needs you" color={(t) => t.palette.warning.main} height={height} />;
    default:
      return <StatusChip label="Running" color={(t) => t.palette.info.main} height={height} />;
  }
};

export default RunStatusChip;
